var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.2087 37.8513H28.9524L28.287 41.9434H25.8737L25.2087 37.8513ZM8.40483 39.8977C14.977 39.8977 14.7274 39.8977 14.8929 39.8977C15.309 39.8158 15.5593 39.4887 15.6417 39.1612C15.7258 38.9971 15.6417 39.4887 15.6417 30.7315C22.2138 30.7315 21.9642 30.7315 22.1307 30.7315C22.5468 30.6496 22.7961 30.4042 22.8785 29.995C22.9626 29.8312 22.8785 30.3223 22.8785 21.5654C29.7012 21.5649 29.1189 21.5654 29.2851 21.5654C29.7836 21.483 30.1171 21.1561 30.1995 20.665C30.1995 20.5833 30.1995 20.5836 30.1995 12.3994L36.4382 12.3992V42.1074H30.3659L31.1979 37.1969C31.2819 36.5422 30.7818 35.9694 30.1995 35.9694H23.961C23.2956 35.9694 22.7961 36.5424 22.9626 37.1971L23.7945 42.1074H20.883C20.3007 42.1074 19.8012 42.5986 19.8012 43.1716C19.8015 43.7439 20.3004 44.2355 20.8827 44.2355C21.7148 44.2352 35.1078 44.2355 36.522 44.2355L36.5222 46.2812H8.40483V39.8977ZM3.16474 36.8695L6.32518 39.3245V44.8899L3.16474 42.4348V36.8695ZM25.0416 15.8364V9.28912L28.203 11.744V18.2913L25.0416 15.8364ZM22.2138 19.4371L19.635 17.3914H23.5449L26.124 19.4371H22.2138ZM17.7225 25.0023V18.4553L20.883 20.9107V27.4579L17.7225 25.0023ZM14.977 28.6037L12.3981 26.5576H16.3083L18.8864 28.6037H14.977ZM10.4847 34.2506V27.7034L13.6459 30.1583V36.706L10.4847 34.2506ZM7.65604 37.8513L5.0772 35.8057H8.98713L11.5662 37.8513H7.65604ZM34.0263 10.1895H29.5347L26.9559 8.14331H30.9483L34.0263 10.1895ZM46.8371 46.036H38.5188V44.972H43.7591C44.3414 44.972 44.8413 44.4809 44.8413 43.9081C44.8413 43.3351 44.3412 42.844 43.7589 42.844H38.5188V41.7801H46.8371C47.4194 41.7801 47.9186 41.2892 47.9186 40.7162C47.9186 40.1432 47.4194 39.6523 46.8371 39.6523H38.5188V38.5879H42.6783C43.2608 38.5879 43.7589 38.0973 43.7589 37.5245C43.7591 36.9515 43.2606 36.4606 42.6783 36.4606L38.5188 36.4603V35.3964H45.839C46.422 35.3964 46.9203 34.9055 46.9203 34.3327C46.9203 33.7597 46.422 33.2686 45.8388 33.2686H38.5188V32.6953H44.7573C45.3396 32.6953 45.8388 32.2047 45.8388 31.6319C45.839 31.0589 45.3396 30.568 44.7573 30.568L38.5188 30.5678C38.5188 10.2709 38.6009 11.0079 38.4347 10.6806C38.3523 10.5163 38.2692 10.3533 38.1027 10.2714C38.1029 10.2709 31.9464 6.26141 31.8633 6.17929C31.698 6.0974 31.5306 6.0155 31.2819 6.0155C23.4618 6.0155 23.961 6.0155 23.8769 6.0155C23.4618 6.0974 23.0457 6.42474 22.9626 6.91586C22.9626 7.07941 22.9626 6.50662 22.9626 15.2638C20.6333 15.2636 16.8063 15.2638 16.7241 15.2638C16.1418 15.2636 15.7257 15.7545 15.7257 16.2456V24.4298C9.07049 24.4298 9.48632 24.4298 9.31985 24.4298C8.90401 24.5116 8.48795 24.839 8.40483 25.3301C8.40483 25.4937 8.40483 24.9209 8.40483 33.6778C1.91606 33.6778 2.16635 33.6778 1.99987 33.6778C1.49998 33.7597 1.16797 34.2508 1.16797 34.6601V42.844C1.16797 43.1713 1.33352 43.417 1.58382 43.6625C7.1578 48.0819 6.82414 47.7546 6.9075 47.8364C7.07397 47.9183 7.24022 48 7.40646 48C8.48819 48 46.0052 48 46.9203 48C47.5028 48 48.0008 47.5091 48.0008 46.9361C47.9186 46.4452 47.4194 46.036 46.8371 46.036Z",
    fill: "url(#paint0_linear_486_1625)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7191 41.862C18.3155 41.862 18.7997 42.3383 18.7997 42.9259C18.7997 43.5133 18.3152 43.9898 17.7189 43.9898C17.121 43.9898 16.6367 43.5135 16.6367 42.9259C16.6367 42.3381 17.121 41.862 17.7191 41.862Z",
    fill: "url(#paint1_linear_486_1625)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4839 17.31C11.0811 17.31 11.5653 17.7862 11.5653 18.3736C11.5653 18.9613 11.0809 19.4373 10.4839 19.4373C9.8866 19.4371 9.40234 18.9615 9.40234 18.3736C9.40234 17.7858 9.8866 17.31 10.4839 17.31Z",
    fill: "url(#paint2_linear_486_1625)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.516 2.98737C38.1123 2.98737 38.5966 3.46411 38.5966 4.05151C38.5968 4.63914 38.1123 5.11519 37.516 5.11519C36.9181 5.11496 36.4336 4.63937 36.4336 4.05151C36.4338 3.46388 36.9181 2.9876 37.516 2.98737Z",
    fill: "url(#paint3_linear_486_1625)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.7566 12.2354C45.3548 12.2354 45.8381 12.7119 45.8381 13.2993C45.8383 13.8872 45.3546 14.3635 44.7566 14.3635C44.1594 14.3632 43.6758 13.8872 43.6758 13.2993C43.676 12.7119 44.1594 12.2356 44.7566 12.2354Z",
    fill: "url(#paint4_linear_486_1625)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.08151 20.4195C1.67876 20.4195 2.16299 20.896 2.16299 21.4834C2.16299 22.0708 1.67853 22.5475 1.08151 22.5475C0.484255 22.5473 0 22.0712 0 21.4834C0 20.8955 0.484255 20.4195 1.08151 20.4195Z",
    fill: "url(#paint5_linear_486_1625)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.5964 26.5576C41.1944 26.5576 41.6786 27.0341 41.6786 27.6217C41.6788 28.2093 41.1944 28.6856 40.5964 28.6856C40.0001 28.6852 39.5156 28.2093 39.5156 27.6217C39.5159 27.0341 40.0001 26.5578 40.5964 26.5576Z",
    fill: "url(#paint6_linear_486_1625)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.40426 2.49637L12.3144 6.75154C9.81847 6.75154 6.74045 6.752 4.49433 6.752L8.40426 2.49637ZM2.16577 8.87981H5.32623V24.5116C5.32623 25.0844 5.82543 25.5755 6.40774 25.5755C6.99005 25.5755 7.32276 25.0846 7.32276 24.5116L7.32298 8.87981H9.40264V15.0176C9.40264 15.5908 9.9016 16.0822 10.4841 16.0822C11.0665 16.082 11.5656 15.5911 11.5656 15.0181V8.87981H14.727C15.1429 8.87981 15.4747 8.6346 15.6411 8.30727C15.8076 7.8978 15.7252 7.4888 15.4746 7.24312L9.2364 0.368317C8.82033 -0.123039 8.07154 -0.122581 7.65547 0.368543L1.41723 7.24266C1.1674 7.57 1.08429 7.97969 1.25053 8.30727C1.33319 8.63437 1.749 8.87981 2.16577 8.87981Z",
    fill: "url(#paint7_linear_486_1625)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.7551 20.4195C44.3375 20.4195 44.8373 20.9106 44.8373 21.4834C44.8373 22.0559 44.3372 22.5475 43.7549 22.5475C43.1726 22.5473 42.6743 22.0564 42.6743 21.4834C42.6743 20.9106 43.1726 20.4195 43.7551 20.4195ZM43.7551 24.5116C45.5021 24.5116 46.9163 23.1201 46.9163 21.4017C46.9163 19.6829 45.5021 18.2917 43.7549 18.2917C42.0082 18.2912 40.5938 19.765 40.5938 21.4834C40.5938 23.202 42.008 24.5116 43.7551 24.5116Z",
    fill: "url(#paint8_linear_486_1625)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2158 3.06877C18.4654 3.06877 18.7157 3.31491 18.7157 3.56035C18.7157 3.8058 18.5492 4.05148 18.2158 4.05148C17.8828 4.05125 17.7173 3.80603 17.7173 3.56035C17.7175 3.31468 17.9662 3.06923 18.2158 3.06877ZM18.2158 6.0974C19.63 6.0974 20.7946 4.95183 20.7946 3.56035C20.7946 2.16911 19.63 1.02307 18.2158 1.02307C16.8016 1.02284 15.6367 2.16934 15.6367 3.56035C15.637 4.9516 16.8013 6.0974 18.2158 6.0974Z",
    fill: "url(#paint9_linear_486_1625)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_486_1625",
    x1: 24.5844,
    y1: 6.0155,
    x2: 24.5844,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_486_1625",
    x1: 17.7182,
    y1: 41.862,
    x2: 17.7182,
    y2: 43.9898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_486_1625",
    x1: 10.4838,
    y1: 17.31,
    x2: 10.4838,
    y2: 19.4373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_486_1625",
    x1: 37.5151,
    y1: 2.98737,
    x2: 37.5151,
    y2: 5.11519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_486_1625",
    x1: 44.7569,
    y1: 12.2354,
    x2: 44.7569,
    y2: 14.3635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_486_1625",
    x1: 1.0815,
    y1: 20.4195,
    x2: 1.0815,
    y2: 22.5475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_486_1625",
    x1: 40.5971,
    y1: 26.5576,
    x2: 40.5971,
    y2: 28.6856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_486_1625",
    x1: 8.446,
    y1: 0,
    x2: 8.446,
    y2: 25.5755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_486_1625",
    x1: 43.755,
    y1: 18.2917,
    x2: 43.755,
    y2: 24.5116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_486_1625",
    x1: 18.2157,
    y1: 1.02307,
    x2: 18.2157,
    y2: 6.0974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon5);
export default __webpack_public_path__ + "static/media/icon5.263243110b4a87245e1fc887dc21a374.svg";
export { ForwardRef as ReactComponent };